(function(){
  function pad(n){return String(n).padStart(2,'0');}
  document.querySelectorAll('[data-deadline]').forEach(function(el){
    var t=Date.parse(el.getAttribute('data-deadline'));
    if(isNaN(t))return;
    function set(u,v){var n=el.querySelector('[data-cd="'+u+'"]');if(n)n.textContent=pad(v);}
    function tick(){
      var s=Math.max(0,Math.floor((t-Date.now())/1000));
      set('d',Math.floor(s/86400));set('h',Math.floor(s/3600)%24);set('m',Math.floor(s/60)%60);set('s',s%60);
    }
    tick();setInterval(tick,1000);
  });
  var drawer=document.getElementById('cart-drawer');
  var scrim=document.querySelector('.drawer-scrim');
  function openD(e){if(!drawer)return;e.preventDefault();drawer.hidden=false;scrim.hidden=false;}
  function closeD(){if(!drawer)return;drawer.hidden=true;scrim.hidden=true;}
  document.querySelectorAll('[data-drawer-open]').forEach(function(a){a.addEventListener('click',openD);});
  document.querySelectorAll('[data-drawer-close]').forEach(function(a){a.addEventListener('click',closeD);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeD();});
  var sort=document.querySelector('[data-sort]');
  if(sort)sort.addEventListener('change',function(){
    var u=new URL(location.href);u.searchParams.set('sort_by',sort.value);location.href=u.toString();
  });
  document.querySelectorAll('.pdp-thumb').forEach(function(b){
    b.addEventListener('click',function(){
      var main=document.getElementById('pdp-main-img');
      if(main)main.src=b.getAttribute('data-full');
      document.querySelectorAll('.pdp-thumb').forEach(function(x){x.classList.remove('on');});
      b.classList.add('on');
    });
  });
  document.querySelectorAll('.tabs .tab').forEach(function(t){
    t.addEventListener('click',function(){
      var root=t.closest('.subwindow');
      root.querySelectorAll('.tab').forEach(function(x){x.classList.remove('on');});
      root.querySelectorAll('.tabpane').forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');
      var p=root.querySelector('[data-pane="'+t.getAttribute('data-tab')+'"]');
      if(p)p.classList.add('on');
    });
  });
})();